import React from 'react';
import { advertisingSponsors, presentingSponsor } from '../data/sponsors';
export function SponsorStrip() {
  return <div className="grid gap-10 lg:grid-cols-12 lg:items-center" data-id="element-157" data-mp="ryr87l54zevc">
      <div className="lg:col-span-4" data-id="element-158" data-mp="n07olre0mf65">
        <p className="text-sm font-medium text-muted" data-id="element-159" data-mp="n190fy2uv5ox">Presented by</p>
        <img src={presentingSponsor.logo} alt={`${presentingSponsor.name} logo`} className="mt-3 h-28 w-auto object-contain" loading="lazy" data-id="element-160" data-mp="i262syp7g1qz" />
      </div>
      <div className="lg:col-span-8" data-id="element-161" data-mp="1aps4g1evgwb7">
        <h2 className="text-sm font-medium text-muted" data-id="element-162" data-mp="1aqtsr7kwffav">Thank you to our advertising sponsors</h2>
        <ul className="mt-4 grid grid-cols-2 items-center gap-x-8 gap-y-6 sm:grid-cols-3 md:grid-cols-4" data-id="element-163" data-mp="15xh5p1vvbgk8">
          {advertisingSponsors.map(s => <li key={s.name} className="flex h-16 items-center justify-center" data-id="element-164" data-mp="1yg4no8fkifh3">
              <img src={s.logo} alt={`${s.name} logo`} className="max-h-16 max-w-full object-contain" loading="lazy" data-id="element-165" data-mp="1towd392i4o2c" />
            </li>)}
        </ul>
      </div>
    </div>;
}